
export function truncateFileNameKeepingExtension(fileName:string,requiredLength:number){
    let str = fileName.split('.');
    return fileName.length > requiredLength ? str[0].substring(0,(requiredLength-4)) + '...' + str[0].substring(str[0].length-2) + '.' + str[1] : fileName
 }